import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
// import auth from "./auth";
import boards from "./boards";
import userdata from "./userdata";
import boardNotes from "./board-notes";
import myTasks from "./my-tasks";
import batteryLevels from "./battery-levels";
import hvidata from "./hvi-data";

const rootReducer = persistReducer(
  {
    key: "root", // key is required
    storage, // storage is now required
    whitelist: ["boards", "userdata", "boardNotes", "myTasks"],
  },
  combineReducers({
    // auth,
    boards,
    userdata,
    boardNotes,
    myTasks,
    batteryLevels,
    hvidata
  })
);

export default rootReducer;
